"use strict";

exports.__esModule = true;
exports.ScheduleInfoView = exports.ScheduleInfoTitle = exports.ScheduleInfoHeader = exports.ScheduleInfo = void 0;
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _luxon = require("luxon");
var _libTimeline = require("@vimana/lib-timeline");
var _reactIntl = require("react-intl");
var _Core = require("../../Core");
var _Theme = require("../../Theme");
var _AgendaInfo = require("../Agenda/AgendaInfo");
var _class, _ScheduleInfo;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var canEditItem = function canEditItem(_ref) {
  var interval = _ref.interval;
  var now = Date.now();
  return interval.startMillis > now;
};
var hasScheduleEnded = function hasScheduleEnded(_ref2) {
  var interval = _ref2.interval;
  var now = Date.now();
  return interval.endMillis < now;
};
var ScheduleInfoView = exports.ScheduleInfoView = _styledComponents["default"].article.withConfig({
  displayName: "ScheduleInfo__ScheduleInfoView",
  componentId: "sc-1lpani1-0"
})(["display:flex;flex-direction:column;"]);
var ScheduleInfoHeader = exports.ScheduleInfoHeader = _styledComponents["default"].button.withConfig({
  displayName: "ScheduleInfo__ScheduleInfoHeader",
  componentId: "sc-1lpani1-1"
})(["display:flex;flex-direction:row;border:none;box-shadow:none;background:transparent;outline:none;text-align:left;justify-content:space-between;align-items:center;"]);
var ScheduleInfoTitle = exports.ScheduleInfoTitle = _styledComponents["default"].h2.withConfig({
  displayName: "ScheduleInfo__ScheduleInfoTitle",
  componentId: "sc-1lpani1-2"
})(["margin-left:1rem;margin-right:1rem;align-items:center;flex:1;color:", ";small{font-weight:normal;color:#777;}"], (0, _Theme.val)("TagTextColor"));
var ScheduleInfoTitleTime = _styledComponents["default"].span.withConfig({
  displayName: "ScheduleInfo__ScheduleInfoTitleTime",
  componentId: "sc-1lpani1-3"
})(["color:", ";font-size:x-small;opacity:0.6;"], (0, _Theme.val)("TagTextColor"));
var ScheduleInfoEditable = _styledComponents["default"].div.withConfig({
  displayName: "ScheduleInfo__ScheduleInfoEditable",
  componentId: "sc-1lpani1-4"
})(["background-color:", ";padding:15px;border-radius:30px;font-size:15px;color:", ";font-weight:bold;"], (0, _Theme.val)("ScheduleFutureTagBackgroundColor"), (0, _Theme.val)("ScheduleFutureTagTextColor"));
var WorkdayOffsetTime = function WorkdayOffsetTime(_ref3) {
  var value = _ref3.value;
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var time = _luxon.DateTime.local().startOf("day").plus({
    milliseconds: value
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", null, time.toLocaleString(_luxon.DateTime.TIME_SIMPLE)), value < 0 && /*#__PURE__*/_react["default"].createElement("small", null, " ", translate("ScheduleInfo.WorkdayOffsetTime.previousDay", "(previous day)")));
};
var ScheduleCallout = function ScheduleCallout(_ref4) {
  var schedule = _ref4.schedule;
  var _React$useContext2 = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext2.translate;
  if (canEditItem(schedule)) {
    return /*#__PURE__*/_react["default"].createElement(_core.Callout, {
      key: "editable-schedule",
      icon: "info-sign",
      intent: "primary",
      title: translate("ScheduleInfo.ScheduleCallout.canEdit.title", "Edit Schedule")
    }, /*#__PURE__*/_react["default"].createElement("p", null, translate("ScheduleInfo.ScheduleCallout.canEdit.content", "This schedule has has not yet started, you can edit it up to 24hrs before it starts.")), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      icon: _icons.IconNames.ADD,
      to: "/calendar/schedules/" + String(schedule.id),
      text: translate("ScheduleInfo.ScheduleCallout.canEdit.editButton", "Edit this schedule")
    }));
  }
  if (hasScheduleEnded(schedule)) {
    return /*#__PURE__*/_react["default"].createElement(_core.Callout, {
      key: "ended-schedule",
      icon: "info-sign",
      title: translate("ScheduleInfo.ScheduleCallout.ended.title", "Schedule has ended")
    }, /*#__PURE__*/_react["default"].createElement("p", null, translate("ScheduleInfo.ScheduleCallout.ended.content", "This schedule has ended, you can't edit past schedules but you can create new schedules based on them:")), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      icon: _icons.IconNames.ADD,
      to: "/calendar/create-schedule?basedOn=" + String(schedule.id),
      text: translate("ScheduleInfo.ScheduleCallout.ended.createScheduleButton", "Create a new schedule based on this one.")
    }));
  }
  return null;
};

/**
 * Displays information about an individual schedule.
 */
var ScheduleInfo = exports.ScheduleInfo = (0, _Core.withTranslator)(_class = (0, _styledComponents.withTheme)(_class = (_ScheduleInfo = /*#__PURE__*/function (_Component) {
  function ScheduleInfo() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      isOpen: _this.props.isInfoOpen
    };
    _this.handleToggleClick = function () {
      var _this$props;
      if (!((_this$props = _this.props) != null && _this$props.isActive)) {
        _this.setState(Object.assign({}, _this.state, {
          isOpen: !_this.state.isOpen
        }));
      }
    };
    return _this;
  }
  _inheritsLoose(ScheduleInfo, _Component);
  var _proto = ScheduleInfo.prototype;
  _proto.render = function render() {
    var _this$props2 = this.props,
      schedule = _this$props2.schedule,
      calendar = _this$props2.calendar,
      translate = _this$props2.translator.translate,
      isActive = _this$props2.isActive,
      theme = _this$props2.theme;
    var isOpen = this.state.isOpen;
    var startTime = calendar.getPlantTime(schedule.interval.startMillis);
    var endTime = schedule.interval.endMillis === _libTimeline.END_OF_TIME ? "forever" : calendar.getPlantTime(schedule.interval.endMillis);
    return /*#__PURE__*/_react["default"].createElement(ScheduleInfoView, null, /*#__PURE__*/_react["default"].createElement(ScheduleInfoHeader, {
      onClick: this.handleToggleClick,
      style: {
        cursor: isActive ? "" : "pointer"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: "calendar",
      size: 48,
      color: theme && theme.color ? theme.color : "defaultColor"
    }), /*#__PURE__*/_react["default"].createElement(ScheduleInfoTitle, null, " ", schedule.name, " ", /*#__PURE__*/_react["default"].createElement(ScheduleInfoTitleTime, null, startTime.toLocaleString(_luxon.DateTime.DATETIME_MED), " -", " ", typeof endTime === "string" ? endTime : endTime.toLocaleString(_luxon.DateTime.DATETIME_MED))), canEditItem(schedule) && /*#__PURE__*/_react["default"].createElement(ScheduleInfoEditable, null, translate("ScheduleInfo.ScheduleStatusInfo.futureSchedule", "Future Schedule")), isActive ? /*#__PURE__*/_react["default"].createElement(_core.Callout, {
      key: "active-schedule",
      intent: "success",
      icon: "info-sign",
      title: translate("ScheduleInfo.ScheduleStatusInfo.currentSchedule", "Current Schedule"),
      style: {
        width: "500px"
      }
    }, /*#__PURE__*/_react["default"].createElement("p", null, translate("ScheduleInfo.ScheduleCallout.content", "This is the active schedule. Schedules can't be edited after they have started but you can create new schedules based on them:")), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
      icon: _icons.IconNames.ADD,
      to: "/calendar/create-schedule?basedOn=" + String(schedule.id),
      text: translate("ScheduleInfo.ScheduleCallout.createButton", "Create a new schedule based on this one.")
    })) : /*#__PURE__*/_react["default"].createElement(_core.Icon, {
      icon: isOpen ? "chevron-up" : "chevron-down",
      title: isOpen ? translate("ScheduleInfo.ScheduleExpandCollapse.collapse", "Collapse") : translate("ScheduleInfo.ScheduleExpandCollapse.expand", "Expand"),
      size: 48,
      color: theme && theme.color ? theme.color : "defaultColor"
    })), /*#__PURE__*/_react["default"].createElement(_core.Collapse, {
      isOpen: isOpen
    }, /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ScheduleInfo.summary",
      defaultMessage: "\n            Schedule runs from {from} until {to}, with workday starting at {offset}.\n           ",
      values: {
        from: /*#__PURE__*/_react["default"].createElement("strong", null, startTime.toLocaleString(_luxon.DateTime.DATETIME_MED)),
        to: /*#__PURE__*/_react["default"].createElement("strong", null, typeof endTime === "string" ? endTime : endTime.toLocaleString(_luxon.DateTime.DATETIME_MED)),
        offset: /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement(WorkdayOffsetTime, {
          value: schedule.workdayOffset
        }))
      }
    })), schedule.agendas.map(function (agenda) {
      return /*#__PURE__*/_react["default"].createElement(_AgendaInfo.AgendaInfo, {
        key: agenda.id,
        agenda: agenda
      });
    }), /*#__PURE__*/_react["default"].createElement(ScheduleCallout, _extends({
      key: "schedule-callout"
    }, this.props))));
  };
  return ScheduleInfo;
}(_react.Component), _ScheduleInfo.defaultProps = {
  translator: undefined,
  theme: undefined
}, _ScheduleInfo)) || _class) || _class;